import { createContext, useState } from "react"

interface IUseSearchByContract {
    idContratoSelecionado: number
    setIdContratoSelecionado: React.Dispatch<React.SetStateAction<number>>
}

export const SearchByContractContext = createContext<IUseSearchByContract>(null)

export const SearchByContractProvider: React.FC = ({ children }) => {
    const [idContratoSelecionado, setIdContratoSelecionado] = useState<number>(0)

    return (
        <SearchByContractContext.Provider
            value={{
                idContratoSelecionado,
                setIdContratoSelecionado,
            }}
        >
            {children}
        </SearchByContractContext.Provider>
    )
}